import React from 'react'
import AddIcon from '@material-ui/icons/Add'

import PageTitle from 'components/PageTitle/PageTitle'
import ButtonStyled from 'components/CommonUI/Button/Button'
import SearchInput from 'components/CommonUI/SearchInput/SearchInput'

import { modalTypesConstant } from '../DevicesManagement'

const PageHeader = ({ handleCreate, searchValue, handleSearchChange }) => {
  return (
    <div className="devices_manage_page_header">
      <PageTitle text="Manage devices" />
      <div className="search_create_block">
        <SearchInput
          placeholder="Search device by keyword"
          classNameContainer="devices_manage_search_input"
          value={searchValue}
          handleChange={handleSearchChange}
        />
        <ButtonStyled
          className="devices_manage_create_button"
          startIcon={<AddIcon />}
          onClick={handleCreate(modalTypesConstant.create)}
          variant="outlined"
        >
          Create new device
        </ButtonStyled>
      </div>
    </div>
  )
}

export default PageHeader
